import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageWrapper } from '../components/layout/PageWrapper';
import { ScoreTable } from '../components/scoreboard/ScoreTable';
import { useSeasons, useSeason } from '../hooks/useScoreboard';
import { useAuthStore } from '../store/authStore';
import { isFreeAdmin } from '../lib/freeAdmins';
import { Seo } from '../components/Seo';

export function ScoreboardPage() {
  const { t } = useTranslation('scoreboard');
  const { user } = useAuthStore();
  const { data: seasons, isLoading: seasonsLoading } = useSeasons();
  const currentSeason = seasons?.find((s) => s.isCurrent) ?? seasons?.[0];
  const [selectedSeasonId, setSelectedSeasonId] = useState<string>('');

  const activeSeason = selectedSeasonId || currentSeason?.seasonId || '';
  const { data: seasonData, isLoading: scoresLoading } = useSeason(activeSeason);

  return (
    <PageWrapper>
      <Seo title="Рейтинг игроков" description="Турнирная таблица и рейтинг игроков Queensland Mafia Club." path="/scoreboard" />

      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <h1 className="text-4xl font-bold text-white">{t('title')}</h1>
        {isFreeAdmin(user?.email) && (
          <div className="flex gap-3">
            <Link to="/admin/scoreboard/players" className="px-5 py-2.5 text-sm font-mono border border-mafia-border text-mafia-paper-dim hover:text-mafia-paper transition-colors">
              Игроки
            </Link>
            <Link to="/admin/scoreboard/new" className="btn-gold-solid px-5 py-2.5 text-sm">
              + Добавить результаты
            </Link>
          </div>
        )}
      </div>

      {seasonsLoading ? (
        <div className="flex justify-center py-20">
          <div className="w-8 h-8 border-2 border-mafia-accent border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <>
          {seasons && seasons.length > 1 && (
            <div className="flex gap-2 mb-6 flex-wrap">
              {seasons.map((s) => (
                <button
                  key={s.seasonId}
                  onClick={() => setSelectedSeasonId(s.seasonId)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    (selectedSeasonId || currentSeason?.seasonId) === s.seasonId
                      ? 'bg-mafia-accent text-white'
                      : 'bg-mafia-card text-gray-300 hover:text-white border border-gray-700'
                  }`}
                >
                  {s.name}
                  {s.isCurrent && (
                    <span className="ml-2 text-xs bg-white/20 px-1.5 py-0.5 rounded-full">
                      {t('current')}
                    </span>
                  )}
                </button>
              ))}
            </div>
          )}

          <div className="bg-mafia-card border border-gray-800 rounded-2xl overflow-hidden">
            {scoresLoading ? (
              <div className="flex justify-center py-12">
                <div className="w-8 h-8 border-2 border-mafia-accent border-t-transparent rounded-full animate-spin" />
              </div>
            ) : seasonData && seasonData.scores.length > 0 ? (
              <ScoreTable data={seasonData} />
            ) : (
              <p className="text-center text-gray-500 py-12">{t('empty')}</p>
            )}
          </div>
        </>
      )}
    </PageWrapper>
  );
}
